module.exports = __webpack_public_path__ + "static/media/statisticChart.4868e5c6.png";